import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {MaterialModule} from '../../../material.module';
import {ConversationPreviewService} from '../../conversations/conversation-preview.service';
import {WidgetPreviewFixtureService, WidgetPreviewFixtureState} from './widget-preview-fixture.service';

@Component({
  selector: 'app-widget-preview-fixture',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './widget-preview-fixture.component.html',
  styleUrls: ['./widget-preview-fixture.component.scss'],
  host: {class: 'webinars-m3 webinars-shell'}
})
export class WidgetPreviewFixtureComponent implements OnInit {
  private readonly fixtureService = inject(WidgetPreviewFixtureService);
  private readonly conversationPreviewService = inject(ConversationPreviewService);

  chatbotId = this.fixtureService.reservedChatbotId;
  clientId = this.fixtureService.reservedClientId;
  fixtureState: WidgetPreviewFixtureState | null = null;
  loading = false;
  errorMessage = '';

  ngOnInit(): void {
    void this.seedAndOpen();
  }

  async seedAndOpen(): Promise<void> {
    await this.runAction(async () => {
      this.fixtureState = await firstValueFrom(this.fixtureService.seedProductCard(this.clientId, this.chatbotId));
      this.openPreview();
    });
  }

  async refresh(): Promise<void> {
    await this.runAction(async () => {
      this.fixtureState = await firstValueFrom(this.fixtureService.getProductCardState(this.clientId, this.chatbotId));
    });
  }

  async reset(): Promise<void> {
    await this.runAction(async () => {
      this.fixtureState = await firstValueFrom(this.fixtureService.resetProductCard(this.clientId, this.chatbotId));
    });
  }

  openPreview(): void {
    if (!this.fixtureState?.conversationId) {
      return;
    }

    this.conversationPreviewService.open({
      conversationId: this.fixtureState.conversationId,
      clientId: this.fixtureState.clientId,
      chatbotId: this.fixtureState.chatbotId,
      title: `Widget preview smoke: ${this.fixtureState.chatbotId}`,
      widgetScriptUrl: this.fixtureService.localWidgetScriptUrl,
      runtimeConfigOverride: {
        ENVIRONMENT: 'development',
        SHINE_AI_WEB_URL: this.fixtureService.localAiWebServerUrl,
        SHINE_AI_API_URL: this.fixtureService.localAiApiServerUrl
      }
    });
  }

  private async runAction(action: () => Promise<void>): Promise<void> {
    this.loading = true;
    this.errorMessage = '';

    try {
      await action();
    } catch (error) {
      console.error('Widget preview fixture action failed', error);
      this.errorMessage = 'The local widget preview fixture request failed. Check the localhost Shine AI Web runtime.';
    } finally {
      this.loading = false;
    }
  }
}
